import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const HeaderDropDownMenu = () => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const { t } = useTranslation();
  const navigate = useNavigate();
  let dropdownTimeout;

  const handleChevronHover = (dropdownName) => {
    clearTimeout(dropdownTimeout);
    setOpenDropdown(dropdownName);
  };

  const handleMouseLeave = () => {
    dropdownTimeout = setTimeout(() => {
      setOpenDropdown(null);
    }, 200);
  };

  const handleDropdownHover = () => {
    clearTimeout(dropdownTimeout);
  };

  const handleDropdownItemClick = (path) => {
    setOpenDropdown(null);
    navigate(path);
  };

  return (
    <div className="relative flex-1">
      <ul className="flex items-center gap-6 2xl:gap-8 overflow-x-auto md:w-auto md:overflow-visible list-none">
        <li
          className="whitespace-nowrap relative flex items-center"
          onMouseEnter={() => handleChevronHover("home")}
          onMouseLeave={handleMouseLeave}
        >
          <a
            href="/"
            className="text-[var(--muted)] hover:text-[var(--brand)] duration-200 text-sm font-medium"
          >
            {t("header.home")}
          </a>
          <span
            className={`ml-1 cursor-pointer text-[var(--muted)] hover:text-[var(--brand)] transition-transform duration-200 h-5 flex items-center justify-center ${
              openDropdown === "home" ? "rotate-180" : ""
            }`}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="6,9 12,15 18,9"></polyline>
            </svg>
          </span>

          {openDropdown === "home" && (
            <ul
              className="absolute top-full left-0 mt-1 bg-white border border-[var(--border)] rounded-[var(--radius)] shadow-lg min-w-[160px] z-50 list-none p-1"
              onMouseEnter={handleDropdownHover}
              onMouseLeave={handleMouseLeave}
            >
              <li>
                <button
                  onClick={() => handleDropdownItemClick("/introduction")}
                  className="block w-full text-left px-4 py-2.5 text-sm text-[var(--muted)] hover:bg-[#EEF2FF] hover:text-[var(--brand)] transition-colors duration-200 rounded-lg"
                >
                  {t("header.introduction")}
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleDropdownItemClick("/Myanmar-earthquake-relief-efforts")}
                  className="block w-full text-left px-4 py-2.5 text-sm text-[var(--muted)] hover:bg-[#EEF2FF] hover:text-[var(--brand)] transition-colors duration-200 rounded-lg"
                >
                  {t("header.myanmar")}
                </button>
              </li>
            </ul>
          )}
        </li>

        <li className="whitespace-nowrap relative">
          <a
            href="/become-a-leader"
            className="text-[var(--muted)] hover:text-[var(--brand)] transition-colors duration-200 text-sm font-medium"
          >
            {t("header.lingo_teacher")}
          </a>
        </li>

        <li className="whitespace-nowrap relative">
          <a
            href="/become-a-learner"
            className="text-[var(--muted)] hover:text-[var(--brand)] transition-colors duration-200 text-sm font-medium"
          >
            {t("header.lingo_learner")}
          </a>
        </li>

        <li className="whitespace-nowrap relative">
          <a
            href="/schedule-meeting"
            className="text-[var(--muted)] hover:text-[var(--brand)] transition-colors duration-200 text-sm font-medium"
          >
            {t("header.schedule_meeting")}
          </a>
        </li>

        <li
          className="whitespace-nowrap relative flex items-center"
          onMouseEnter={() => handleChevronHover("blog")}
          onMouseLeave={handleMouseLeave}
        >
          <a
            href="/conversation-questions"
            className="text-[var(--muted)] hover:text-[var(--brand)] duration-200 text-sm font-medium"
          >
            {t("header.conversation_questions")}
          </a>
          <span
            className={`ml-1 cursor-pointer text-[var(--muted)] hover:text-[var(--brand)] transition-transform duration-200 h-5 flex items-center justify-center ${
              openDropdown === "blog" ? "rotate-180" : ""
            }`}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="6,9 12,15 18,9"></polyline>
            </svg>
          </span>

          {openDropdown === "blog" && (
            <ul
              className="absolute top-full left-0 mt-1 bg-white border border-[var(--border)] rounded-[var(--radius)] shadow-lg min-w-[180px] z-50 list-none p-1"
              onMouseEnter={handleDropdownHover}
              onMouseLeave={handleMouseLeave}
            >
              <li>
                <button
                  onClick={() => handleDropdownItemClick("/conversation-questions")}
                  className="block w-full text-left px-4 py-2.5 text-sm text-[var(--muted)] hover:bg-[#EEF2FF] hover:text-[var(--brand)] transition-colors duration-200 rounded-lg"
                >
                  {t("header.1400_questions")}
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleDropdownItemClick("/Java-Syllabus")}
                  className="block w-full text-left px-4 py-2.5 text-sm text-[var(--muted)] hover:bg-[#EEF2FF] hover:text-[var(--brand)] transition-colors duration-200 rounded-lg"
                >
                  {t("header.java_syllabus")}
                </button>
              </li>
            </ul>
          )}
        </li>

        <li className="whitespace-nowrap relative">
          <a
            href="/our-team"
            className="text-[var(--muted)] hover:text-[var(--brand)] transition-colors duration-200 text-sm font-medium"
          >
            {t("header.our_team")}
          </a>
        </li>
      </ul>
    </div>
  );
};

export default HeaderDropDownMenu;
